import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../../hoc/Loading/Loading";
import axios from "../../../../axios";
import * as actionCreators from "../../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../../utils/url";
import DashboardChartList from "./AddCharts/DashboardChartList";
import {
  Card,
  CardBody,
  CardImg,
  Button,
  CardTitle,
  CardText,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import Checkbox from "rc-checkbox";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import DashboardSettings from "./DashboardSettings/DashboardSettings";
import DashboardNotesItem from "./AddNotes/DashboardNotesItem";
import DashboardNotesList from "./AddNotes/DashboardNotesList";
import moment from "moment";

class DashboardCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedFields: [],
      title: "",
      isChartList: false,
      url: "",
      dashboardCharts: [],
      dashboardTools: [],
      currentDashboard: {},
      notes: [],
      charts: [],
      attachments: [],
      isResourceSelect: null,
      searchedTerm: "",
      shouldUpdate: false,
      startDate: null,
      endDate: null,
    };
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log('this.props.match: ')
  //   let prev_ch  = prevState.match.params
  //   let current_ch = this.props.match.params
  //   if(current_ch!=prev_ch){
  //     this.retrieveDashboard()
  //   }
  // }

  componentWillUnmount() {
    this.props.updateNavBar({
      backButtonData: {
        show: false,
        currentPageType: "",
      },
    });
  }

  componentDidMount() {
    // console.log('dashboardCreate.jsx----')
    this.retrieveDashboard();

    this.props.updateNavBar({
      backButtonData: {
        show: true,
        currentPageType: "DASHBOARD_DETAILS",
      },
    });
  }

  retrieveDashboard = () => {
    // console.log('retrieve: ', this.props)
    let { id } = this.props.match.params,
      that = this;
    // return
    // axios.all([
    //   axios.post(url.getDashboard, {_id: id}),
    //   // axios.post(url.getDashboardCharts, {dashboardId:id}),
    // ])
    axios
      .post(url.getDashboard, { _id: id })
      .then(({ data }) => {
        let currentDashboard = data.data;
        // console.log('dashboard: ', data)
        // let dashboardCharts = chartList.data.data
        // console.log('new dashboard: ', currentDashboard)
        const queryParams = new URLSearchParams(window.location.search);

        if(queryParams.get("report")){
          currentDashboard = { ...currentDashboard, hideCharts: true };
        }else{
          currentDashboard = { ...currentDashboard, hideCharts: false };
        }
       
        that.setState({ currentDashboard });
        that.props.updateReport(currentDashboard);
        // this.props.updateReport({hideCharts: !isNotesDisplay})
      })
      .catch(error => {
        console.log("error: ", error);
      });
  };

  changeDashboardTitle = name => {
    // let{reports}=this.props
    let { currentDashboard } = this.state;
    let obj = {
      ...currentDashboard,
      name,
    };
    this.setState({ currentDashboard: obj });

    this.props.updateReport(obj);
  };

  onDateChange = (startDate, endDate) => {
    let { currentDashboard } = this.state;
    console.log("START --- ", startDate);
    console.log("END ---- ", endDate);

    let dashboardDateUpdate = new Date();
    // let a = startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z';
    let startD = moment.utc(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z";
    let endD = moment.utc(endDate).format("YYYY-MM-DD") + "T23:59:59.000Z";

    //  console.log('a : ', a)
    console.log("s1:  ", startDate);
    console.log("e1:  ", endDate);

    let s1 = moment(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z";

    console.log("startD - ", startD);
    console.log("s1 - ", s1);

    let results = {
      ...currentDashboard,
      startDate,
      endDate,
      dashboardDateUpdate,
    };

    let that = this;

    results = {
      ...results,
      startD,
      s1,
      old_date_range: {
        startDate: currentDashboard.startDate,
        endDate: currentDashboard.endDate,
      },
    };

    let obj = { s1, startD, ...results };

    axios
      .post(url.dashboardDateChange, obj)
      .then(response => {
        let dashboard = response.data.data;
        // console.log('dashboard date updated: ', response.data)
        delete dashboard.createdBy;

        that.props.updateReport(dashboard);

        // let {chart, dashboard} = response.data.data;
        // let updatedChart = this.processKpiData(chart, {startDate, endDate});
        // delete dashboard.createdBy
        // dashboard={...dashboard, isDateUpdated:false}

        // that.props.updateReport(dashboard)
        // that.setState({chart: {...updatedChart} })
        // that.props.updateReportCharts(updatedChart)
      })
      .catch(error => {
        console.log("err--", error);
      });
    // .finally(()=> {
    //   this.setState({isLoading:false})
    // })
    // this.setState({ currentDashboard:obj, startDate, endDate })
  };

  navigate = () => {
    this.props.history.push("/home/analytics/all");
  };

  closeActionsModal = () => {
    this.setState({
      isResourceSelect: null,
    });
  };

  setCharts = charts => {
    this.setState({ charts });
  };

  saveDashboard = result => {
    let { charts, dashboardCharts } = this.state;

    // remove _id from charts
    let mod_charts = charts.map(e => {
      e = { ...e, _id: null };
      delete e._id;
      return e;
    });

    if (mod_charts.length > 0) {
      result.lastUpdate = {
        type: "Added charts",
        content: `${mod_charts.map(e => e.name)}`,
      };
    }

    let that = this;

    axios
      .all([
        axios.post(url.updateDashboard, result),
        mod_charts.length > 0
          ? axios.post(url.insertCharts, { insert_charts: mod_charts })
          : null,
      ])
      .then(
        axios.spread(function (dashboard, chartList = []) {
          let currentDashboard = dashboard.data.data;
          let new_charts = chartList.data.data;
          dashboardCharts = [...new_charts, ...dashboardCharts];
          that.setState({
            currentDashboard,
            dashboardCharts,
            charts: [],
          });
        })
      )
      .catch(error => {
        console.log(error);
      });
  };

  updateDashboardSettings = updateSettings => {
    // updateSettings
    let that = this;
    axios
      .post(url.updateDashboard, updateSettings)
      .then(response => {
        let updatedDashboard = response.data.data;
        that.setState(prevState => ({
          ...updatedDashboard,
          currentDashboard: updatedDashboard,
          title: updatedDashboard.name,
          shouldUpdate: !prevState.shouldUpdate,
        }));
      })
      .catch(error => {
        console.log(error);
      });
  };

  newDashboardUrl = url => {
    this.props.history.push(url);
    // this.retrieveDashboard()
  };

  render() {
    let { dashboardCharts, currentDashboard, isResourceSelect, shouldUpdate } =
      this.state;
    if (currentDashboard && currentDashboard.name) {
      // console.log('dashboardCreate: ', currentDashboard)
      return (
        <div className="dashboardCreateContainerBox col-md-11">
          <DashboardSettings
            currentDashboard={currentDashboard}
            shouldUpdate={shouldUpdate}
            dashboardOwner={currentDashboard.createdBy}
            startDate={currentDashboard.startDate}
            endDate={currentDashboard.endDate}
            saveDashboard={this.saveDashboard}
            changeDashboardTitle={this.changeDashboardTitle}
            onDateChange={this.onDateChange}
            newDashboardUrl={this.newDashboardUrl}
            updateDashboardSettings={this.updateDashboardSettings}
          />

          <div className="dashboardNotesContainer">
            <DashboardNotesItem
              reports={this.props.reports}
              isUploadFiles={this.props.reports.isUploadFiles}
              currentDashboard={currentDashboard}
            />
          </div>

          <DashboardNotesList />

          <DashboardChartList
            closeActionsModal={this.closeActionsModal}
            startDate={this.props.reports.startDate}
            setCharts={this.setCharts}
            dashboardDateUpdate={currentDashboard.dashboardDateUpdate}
            endDate={this.props.reports.endDate}
            isResourceSelect={isResourceSelect}
            currentDashboard={currentDashboard}
          />
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardCreate, axios)));
